/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import preguntas_estamos_home from '../../../Recursos/preguntas_estamos_home.png'
import {theme} from "../../../Tema";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {iniciarChatWass} from "../../../Utilidades/iniciarChatWass";
import {NUMEROATENCION} from "../../../Constantes";


const Preguntas_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            direction={'row-reverse'}
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: theme.palette.info.main,
                color: 'white',
                borderRadius: 4,
                paddingX: 2,
                paddingY: !sCell ? 2 : 1,
                minHeight: 265
            }}
        >


            <Grid container

                  size={{xs: 12, sm: 12, md: 6}}
                  sx={{paddingY: 2}}>
                <Typography component="h3"
                            sx={{
                                fontSize: sCell ? 30 : 32, fontWeight: 900, textAlign: {xs: 'center', md: 'left'},
                                lineHeight: 1.1,
                            }}>
                    ¿Tienes preguntas? Estamos aquí para ayudarte.
                </Typography>
                <Typography variant="body1" component="p"
                            sx={{textAlign: {xs: 'center', md: 'left', fontSize: {xs: 16, md: 16}, marginTop: sCell ? 10 :  8}}}>
                    En Congenar, tu satisfacción es nuestra prioridad. Contáctanos y recibe atención personalizada para
                    resolver tus dudas, gestionar pedidos o recibir asesoría especializada.
                </Typography>
                <Grid
                    container
                    size={{xs: 12, sm: 12, md: 12}}
                    justifyContent={{xs: 'center', md: 'flex-start'}}
                    alignItems={'flex-end'}
                    sx={{marginTop: 3}}>
                    <Button
                        onClick={() => iniciarChatWass(NUMEROATENCION)}
                        sx={{
                            fontSize: 14,
                            color: theme.palette.info.main,
                            background: 'white',
                            borderRadius: '9999px',
                            paddingY: '10px',
                        }}>
                        <Typography sx={{fontSize: 16, fontWeight: 800}}>
                            MÁS INFORMACIÓN
                        </Typography>
                    </Button>
                </Grid>
            </Grid>

            <Grid container
                  justifyContent={'center'}
                  alignItems={'center'}
                  size={{xs: 12, sm: 12, md: 6}}

            >

                <img src={preguntas_estamos_home} width={sCell ? 320 : 370}
                     style={{marginBottom: !sCell ? -16 : -8, marginTop: sCell ? 0 : -170}}
                     alt="Estamos para responder tus preguntas"/>


            </Grid>
        </Grid>
    )
}
export default Preguntas_Home